export enum AvailableTabs {
  customer = 'customer',
  specifications = 'specifications',
  items = 'items',
  notes = 'notes',
  stops = 'stops',
}

export enum TransportProAppointmentStatus {
  NotRequired = 'fcfs',
  AppointmentRequired = 'appointment_required',
  Requested = 'requested',
  Denied = 'denied',
  Confirmed = 'confirmed',
}

export const TRANSPORT_PRO_UPDATE_APPOINTMENT_STATUS_OPTIONS = [
  {
    value: TransportProAppointmentStatus.AppointmentRequired,
    label: 'Appointment Required',
  },
  {
    value: TransportProAppointmentStatus.Requested,
    label: 'Requested',
  },
  {
    value: TransportProAppointmentStatus.Confirmed,
    label: 'Confirmed',
  },
  {
    value: TransportProAppointmentStatus.Denied,
    label: 'Denied',
  },
] as const;

export const TRANSPORT_PRO_PRIORITY_NOTE_TYPE = 'priority';
